
// Test data for Level 1 Iron Training

export const ironTests = [
  {
    id: "iron-long",
    title: "Fers longs",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 1, 3, 5 m. Taper 10 balles depuis la distance de 150 m et compter les points selon le cercle d'arrivée.",
    icon: "🏌️‍♂️"
  },
  {
    id: "iron-mid",
    title: "Fers moyens",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 1, 3, 5 m. Taper 10 balles depuis la distance de 120 m et compter les points selon le cercle d'arrivée.",
    icon: "🏌️‍♂️"
  },
  {
    id: "iron-green-attack",
    title: "Attaque de green 120 m",
    description: "Sur le parcours choisissez un trou et imaginez 3 zones cibles matérialisées par des cercles de 1, 3, 5 m. Vous partagez le green en 4 zones : bas gauche, haut gauche, bas droit et haut droit. L'exercice consiste à taper 10 balles depuis la distance de 120 m, vous notez les points en fonction des cercles d'arrivées et les tendances bas gauche, haut gauche, bas droit et haut droit.",
    icon: "🎯"
  },
  {
    id: "iron-green-attack-100",
    title: "Attaque de green 100 m",
    description: "Sur le parcours choisissez un trou et imaginez 3 zones cibles matérialisées par des cercles de 1, 3, 5 m. Vous partagez le green en 4 zones : bas gauche, haut gauche, bas droit et haut droit. L'exercice consiste à taper 10 balles depuis la distance de 100 m, vous notez les points en fonction des cercles d'arrivées et les tendances bas gauche, haut gauche, bas droit et haut droit.",
    icon: "🎯"
  }
];
